import { render, staticRenderFns } from "./CourseWiseEnrollmentCount.vue?vue&type=template&id=35bbbdf5&"
import script from "./CourseWiseEnrollmentCount.vue?vue&type=script&lang=js&"
export * from "./CourseWiseEnrollmentCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports